export const URL_DOWNLOAD = "https://rrrbets.com/app/rrrBets.apk";
